import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight, Award, Users, Clock, TrendingUp, Shield, Heart } from 'lucide-react';

const cards = [
  { icon: Award, title: 'Professional', desc: 'We strive to excel every day by doing better than the last day until we reach our goal — financial freedom. Our team holds the highest professional standards.' },
  { icon: Users, title: 'Each Customer Is Valued', desc: 'With over eight years in Accounting and Taxation, we can ensure the best possible outcome for all your obligations. You are not just a tax return to us.' },
  { icon: Clock, title: 'Quick Turnaround', desc: 'We always consider the unique needs of our clients before providing accounting and advisory services. Fast, accurate, and always on time.' },
  { icon: TrendingUp, title: 'We Are Reliable', desc: 'Committed to being dependable partners for your financial needs, providing consistent and trustworthy service across every engagement.' },
  { icon: Shield, title: 'Cost Effective', desc: 'Competitive, transparent pricing with no hidden fees. Quality accounting services that deliver real value for your investment.' },
  { icon: Heart, title: 'We Are Qualified', desc: 'Qualified Accountants and Tax Professionals with a wealth of knowledge and industry experience that exceeds your expectations.' },
];

export default function WhyChooseUs() {
  return (
    <div className="page-enter">
      <style>{`
        .page-hero { background: var(--charcoal-dark); padding: 72px 0; position: relative; overflow: hidden; }
        .page-hero-img { position:absolute; inset:0; background-image:url('https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1600&h=500&fit=crop&q=80'); background-size:cover; background-position:center; filter:saturate(1.05) brightness(0.9); }
        .page-hero-overlay { position:absolute; inset:0; background: linear-gradient(90deg, rgba(26,26,24,0.94) 0%, rgba(26,26,24,0.8) 35%, rgba(26,26,24,0.45) 68%, rgba(26,26,24,0.2) 100%); }
        .page-hero::before { content:''; position:absolute; right:0; top:0; bottom:0; width:40%; background: radial-gradient(circle at 80% 50%, rgba(201,168,76,0.14),transparent 70%); pointer-events:none; z-index:1; }
        .ph-breadcrumb { font-size:12px; color:rgba(255,255,255,0.4); margin-bottom:12px; }
        .ph-breadcrumb a { color:var(--gold); }
        .ph-title { font-family:var(--font-display); font-size:clamp(32px,4vw,52px); font-weight:700; color:white; line-height:1.15; margin-bottom:12px; }
        .ph-title em { font-style:italic; color:var(--gold); }
        .ph-sub { font-size:16px; font-weight:300; color:rgba(255,255,255,0.6); max-width:580px; line-height:1.75; }
        .why-intro { padding:88px 0; background:var(--white); }
        .why-intro-grid { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:start; }
        .wil-quote { border-left:4px solid var(--gold); border-radius:0 var(--radius-sm) var(--radius-sm) 0; padding:24px 28px; background:var(--gold-bg); font-family:var(--font-display); font-size:18px; font-style:italic; color:var(--charcoal-dark); line-height:1.65; margin-bottom:28px; }
        .wil-text { font-size:15px; line-height:1.85; color:var(--text-body); margin-bottom:18px; }
        .why-checks { display:flex; flex-direction:column; gap:12px; margin-top:24px; }
        .why-check { display:flex; align-items:flex-start; gap:10px; font-size:14px; color:var(--text-body); }
        .why-check svg { color:var(--gold); flex-shrink:0; margin-top:2px; }
        .wir-box { background:var(--charcoal-dark); padding:44px 40px; border-radius:var(--radius); }
        .wirb-title { font-family:var(--font-display); font-size:24px; font-weight:700; color:white; margin-bottom:16px; }
        .wirb-text { font-size:14px; line-height:1.8; color:rgba(255,255,255,0.6); margin-bottom:28px; }
        .wirb-vals { display:flex; flex-direction:column; gap:12px; margin-bottom:28px; }
        .wirb-val { display:flex; align-items:center; gap:10px; font-size:14px; color:rgba(255,255,255,0.7); }
        .wirb-dot { width:6px; height:6px; background:var(--gold); border-radius:50%; flex-shrink:0; }
        .wir-reg-box { background:var(--off-white); border:1px solid var(--border); border-radius:var(--radius-sm); padding:28px; margin-top:20px; }
        .wreg-title { font-size:12px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-bottom:14px; }
        .wreg-item { display:flex; align-items:center; gap:8px; padding:9px 0; border-bottom:1px solid var(--border-light); font-size:14px; color:var(--text-body); }
        .wreg-item:last-child { border-bottom:none; }
        .wreg-dot { width:5px; height:5px; background:var(--gold); border-radius:50%; flex-shrink:0; }
        .why-cards-section { background:var(--off-white); padding:88px 0; }
        .why-cards-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:22px; margin-top:52px; }
        .wc-card { background:var(--white); border:1px solid var(--border); border-radius:var(--radius); box-shadow:var(--shadow-sm); padding:40px 32px; transition:all 0.28s ease; position:relative; overflow:hidden; }
        .wc-card::after { content:''; position:absolute; top:0; left:0; right:0; height:3px; background:var(--gold); transform:scaleX(0); transform-origin:left; transition:transform 0.3s; }
        .wc-card:hover::after { transform:scaleX(1); }
        .wc-card:hover { background:var(--charcoal-dark); transform:translateY(-4px); box-shadow:var(--shadow-lg); }
        .wcc-icon { color:var(--gold); margin-bottom:18px; transition:transform 0.3s; }
        .wc-card:hover .wcc-icon { transform:scale(1.1); }
        .wcc-title { font-family:var(--font-display); font-size:19px; font-weight:700; color:var(--text-dark); margin-bottom:12px; transition:color 0.28s; }
        .wc-card:hover .wcc-title { color:white; }
        .wcc-desc { font-size:14px; line-height:1.75; color:var(--text-light); transition:color 0.28s; }
        .wc-card:hover .wcc-desc { color:rgba(255,255,255,0.6); }
        @media (max-width:900px) { .why-intro-grid{grid-template-columns:1fr;gap:40px;} .why-cards-grid{grid-template-columns:1fr 1fr;} }
        @media (max-width:560px) { .why-cards-grid{grid-template-columns:1fr;} }
      `}</style>

      <div className="page-hero">
        <div className="page-hero-img" />
        <div className="page-hero-overlay" />
        <div className="container" style={{position:'relative',zIndex:2}}>
          <div className="ph-breadcrumb"><Link to="/">Home</Link> / Why Choose Us</div>
          <h1 className="ph-title">Why Choose <em>Trinity</em></h1>
          <p className="ph-sub">Trinity Accountants is committed to helping clients manage their business and grow by providing first-class accounting and advisory services.</p>
        </div>
      </div>

      <section className="why-intro">
        <div className="container">
          <div className="why-intro-grid">
            <div>
              <span className="section-eyebrow">Our Promise</span>
              <h2 className="section-title">Where Each Customer<br /><em>Is Valued</em></h2>
              <div className="wil-quote">"We aim to evolve with our customers by actively engaging with them, anticipating their future needs."</div>
              <p className="wil-text">As industries change and businesses evolve, we are always up to date and helping our customers stay one step ahead. We support our clients at various stages of their business and life events in their efforts to build long-term relationships.</p>
              <p className="wil-text">The company promotes an environment of mutual respect and teamwork and firmly encourages work-life balance. We believe that a happy team leads to happy customers.</p>
              <div className="why-checks">
                {['We are Reliable','Cost Effective Service','Fully Qualified Accountants','Personalised Approach','Quick Turnaround','Open & Honest Communication'].map(item => (
                  <div key={item} className="why-check"><CheckCircle2 size={17} />{item}</div>
                ))}
              </div>
            </div>
            <div>
              <div className="wir-box">
                <div className="wirb-title">Our Commitment to You</div>
                <p className="wirb-text">We are Qualified Accountants and Tax Professionals with a wealth of knowledge and industry experience. We provide accounting and advisory advice that exceeds your expectations.</p>
                <div className="wirb-vals">
                  {['Mutual Respect & Integrity','Open & Honest Communication','Cooperative Teamwork','Work-Life Balance Culture','Client-First Approach'].map(v => (
                    <div key={v} className="wirb-val"><div className="wirb-dot" />{v}</div>
                  ))}
                </div>
                <Link to="/contact" className="btn-primary">
                  Talk to Our Team <ArrowRight size={14} />
                </Link>
              </div>
              <div className="wir-reg-box">
                <div className="wreg-title">We Are Registered With</div>
                {['CPA Australia','Registered Tax Agents (ATO)','ASIC Registered Agent Practice','Xero Certified Advisor','MYOB Certified'].map(r => (
                  <div key={r} className="wreg-item"><div className="wreg-dot" />{r}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-cards-section">
        <div className="container">
          <div style={{textAlign:'center'}}>
            <span className="section-eyebrow">Our Strengths</span>
            <h2 className="section-title">Why We Are <em>Different</em></h2>
          </div>
          <div className="why-cards-grid">
            {cards.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="wc-card">
                <Icon size={28} className="wcc-icon" />
                <div className="wcc-title">{title}</div>
                <div className="wcc-desc">{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
